'use strict';
module.exports = require('../../full/object/get-own-property-names');



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/features/object/get-own-property-names.js
// module id = 608
// module chunks = 13